function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 82.32a60.88 60.88 0 0 0 7.56.49A60.44 60.44 0 0 0 79 22.37 60.71 60.71 0 0 0 77.73 10H11z",
  fill: "#bfe6e5"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 36.11,
  cy: 40.25,
  r: 14.89,
  fill: "#fff"
});

var SvgIcon5 = function SvgIcon5(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 115 115",
    ref: svgRef
  }, props), React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref2, _ref3, React.createElement("circle", {
    className: "expectations",
    cx: 89.11,
    cy: 90.25,
    r: 14.89,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#33c100"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_5.0b30b99c.svg";
export { ForwardRef as ReactComponent };